<template>
  <v-main class="pt-0">
    <v-container fluid class="containerSize mb-16">
      <NavigationConfirmationDialog
        v-if="showNavigationConfirmationDialog"
        @confirm-navigation="navigateToRoute"
        @cancel-navigation="showNavigationConfirmationDialog = false"
      />
      <!-- My Primerica Header -->
      <v-row class="justify-start">
        <v-col cols="1" class="text-left">
          <!-- My Primerica Header -->
          <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="28" cy="28" r="28" fill="#D2DEE9" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M32.125 10H17.625C15.6313 10 14 11.62 14 13.6V42.4C14 44.38 15.6131 46 17.6069 46H39.375C41.3687 46 43 44.38 43
            42.4V20.8L32.125 10ZM35.75 28H21.25V31.6H35.75V28ZM35.75 35.2H21.25V38.8H35.75V35.2ZM17.625 42.4H39.375V22.6H30.3125V13.6H17.625V42.4Z"
              fill="black"
            />
            <mask
              id="mask0_1135_1943"
              style="mask-type: luminance"
              maskUnits="userSpaceOnUse"
              x="14"
              y="10"
              width="29"
              height="36"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M32.125 10H17.625C15.6313 10 14 11.62 14 13.6V42.4C14 44.38 15.6131 46 17.6069 46H39.375C41.3687 46 43 44.38 43
              42.4V20.8L32.125 10ZM35.75 28H21.25V31.6H35.75V28ZM35.75 35.2H21.25V38.8H35.75V35.2ZM17.625 42.4H39.375V22.6H30.3125V13.6H17.625V42.4Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0_1135_1943)">
              <rect x="3" y="3" width="50" height="50" fill="#063562" />
              <mask
                id="mask1_1135_1943"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="3"
                y="3"
                width="50"
                height="50"
              >
                <rect x="3" y="3" width="50" height="50" fill="white" />
              </mask>
              <g mask="url(#mask1_1135_1943)" />
            </g>
          </svg>
          <div>
            <MessageDialog
              :show-dialog="showErrorPostPolicyReinstatement"
              :has-button-two="false"
              type="error"
              :title="$t('L_submission_error')"
              :message="$t('L_an_issue_has_occurred_please_try_again_later')"
              :button-one-label="$t('L_OK')"
              :is-persistent="true"
              @buttonOneAction="showErrorPostPolicyReinstatement = false"
            />
          </div>
        </v-col>
        <v-col class="text-left" :class="$vuetify.display.xs ? 'font-size--16' : 'font-size--20'">
          <div
            class="text-white mt-3 font-size--20 font-bold text-left mobile-title-policy-request"
          >
            {{ $t('L_policy_reinstatement_request') }}
          </div>
        </v-col>
        <!-- Policy Number -->
        <v-col class="text-right" v-if="!$vuetify.display.xs">
          <div class="text-white font-size--14 mt-4">
            {{ $t('L_policy_number') }}:
            <span class="font-weight-regular">{{ getContractId }}</span>
          </div>
        </v-col>
      </v-row>
      <!-- New York and 3rd Party Policies-->
      <v-row v-if="goToAOFlow">
        <v-card class="fullWidth pt-4 pb-4">
          <!-- NY and 3rd First Step -->
          <ReinstatementNYStepThree
            v-if="nyPolicyReinstatementStep === 1"
            :disable-actions="asyncProcessInProgress"
            @continue-to-the-next-reinstatement-step="continueToNYFinalStep"
            @cancelClicked="cancelFromReinstatementStep()"
          />
          <!-- Last step for NY and 3rd step -->
          <ReinstatementOriginalIssueNextSteps
            v-if="nyPolicyReinstatementStep === 2"
            :disable-actions="asyncProcessInProgress"
            :is-ny-or-third-party="goToAOFlow"
            @continueClicked="goToDashboard()"
          />
        </v-card>
      </v-row>
      <!-- Non New York and Non 3rd Party Policies -->
      <v-stepper v-else v-model="policyReinstatementStep" :vertical="isMobileView">
        <v-stepper-header v-show="!isMobileView">
          <v-stepper-item :complete="policyReinstatementStep > 1" value="1">
            {{ $t('reinstatement_process_step_overview_header') }}
          </v-stepper-item>
          <v-divider />
          <v-stepper-item :complete="policyReinstatementStep > 2" value="2">
            {{ $t('reinstatement_process_step_options_header') }}
          </v-stepper-item>
          <v-divider />
          <v-stepper-item :complete="policyReinstatementStep > 3" value="3">
            {{ $t('reinstatement_process_step_information_header') }}
          </v-stepper-item>
          <v-divider />
          <v-stepper-item :complete="policyReinstatementStep > 4" value="4">
            {{ $t('reinstatement_process_step_next_steps_header') }}
          </v-stepper-item>
          <v-divider />
        </v-stepper-header>
        <div v-if="asyncProcessInProgress" class="text-center ma-4">
          <v-progress-circular indeterminate color="primary" />
        </div>
        <v-stepper-window>
          <v-stepper-item
            :complete="policyReinstatementStep > 1"
            value="1"
            v-if="isMobileView"
            :class="policyReinstatementStep === '1' ? 'my-step-complete' : ''"
          >
            {{ $t('reinstatement_process_step_overview_header') }}
          </v-stepper-item>
          <v-stepper-window-item value="1">
            <ReinstatementProcessOverview
              :disable-actions="asyncProcessInProgress"
              @continueClicked="continueToTheNextReinstatementStep"
              @cancelClicked="cancelFromReinstatementStep()"
            />
          </v-stepper-window-item>

          <v-stepper-item
            :complete="policyReinstatementStep > 2"
            value="2"
            v-if="isMobileView"
            :class="policyReinstatementStep === '2' ? 'my-step-complete' : ''"
          >
            {{ $t('reinstatement_process_step_options_header') }}
          </v-stepper-item>
          <v-stepper-window-item value="2">
            <ReinstatementProcessOptions
              :disable-actions="asyncProcessInProgress"
              @userOption="setReinstatementOption"
              @continueClicked="continueToTheNextReinstatementStep"
              @cancelClicked="cancelFromReinstatementStep()"
            />
          </v-stepper-window-item>

          <v-stepper-item
            :complete="policyReinstatementStep > 3"
            value="3"
            v-if="isMobileView"
            :class="policyReinstatementStep === '3' ? 'my-step-complete' : ''"
          >
            {{ $t('reinstatement_process_step_information_header') }}
          </v-stepper-item>
          <v-stepper-window-item value="3">
            <ReinstatementProcessInformation
              v-if="userSelectedReinstatmentOption === 1"
              :disable-actions="asyncProcessInProgress"
              @continue-to-the-next-reinstatement-step="continueToTheNextReinstatementStep"
              @backClicked="goToPreviousPage()"
            />
            <ReinstatementOriginalIssueDate
              v-else-if="userSelectedReinstatmentOption === 0"
              :disable-actions="asyncProcessInProgress"
              @continue-to-the-next-reinstatement-step="continueToTheNextReinstatementStep"
              @backClicked="goToPreviousPage()"
            />
          </v-stepper-window-item>

          <v-stepper-item
            :complete="policyReinstatementStep > 4"
            value="4"
            v-if="isMobileView"
            :class="policyReinstatementStep === '4' ? 'my-step-complete' : ''"
          >
            {{ $t('reinstatement_process_step_next_steps_header') }}
          </v-stepper-item>
          <v-stepper-window-item value="4">
            <ReinstatementProcessNextSteps
              v-if="userSelectedReinstatmentOption === 1"
              :disable-actions="asyncProcessInProgress"
              @continueClicked="continueToTheNextReinstatementStep"
              @cancelClicked="cancelFromReinstatementStep()"
            />
            <div v-else-if="userSelectedReinstatmentOption === 0">
              <ReinstatementOriginalIssueNextSteps
                :disable-actions="asyncProcessInProgress"
                :is-ny-or-third-party="goToAOFlow"
                @continueClicked="goToDashboard()"
              />
            </div>
          </v-stepper-window-item>
        </v-stepper-window>
      </v-stepper>
    </v-container>
  </v-main>
</template>

<script lang="ts">
import { openInNewWindow } from '@/mixins/openNewWindow';
import MessageDialog from '@/components/MessageDialog.vue';
import ReinstatementProcessOverview from '../components/ReinstatementProcessOverview.vue';
import ReinstatementProcessOptions from '../components/ReinstatementProcessOptions.vue';
import ReinstatementProcessInformation from '../components/ReinstatementProcessInformation.vue';
import ReinstatementProcessNextSteps from '../components/ReinstatementProcessNextSteps.vue';
import NavigationConfirmationDialog from '../../../components/NavigationConfirmation/NavigationConfirmationDialog.vue';
import ReinstatementOriginalIssueDate from '../components/ReinstatementOriginalIssueDate.vue';
import ReinstatementOriginalIssueNextSteps from '../components/ReinstatementOriginalIssueNextSteps.vue';
import ReinstatementNYStepThree from '../components/ReinstatementNYStepThree.vue';
import { mapActions, mapState, mapStores } from 'pinia';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { useGlobalStore } from '@/stores/global/global.store';
import { useReinstatementStore } from '@/modules/Reinstatement/store/reinstatement.store';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { CapacitorFacade } from '@/plugins/capacitorPlugin';
import { defineComponent, type ComponentOptions } from 'vue';
import type { IPolicyStorePolicy } from '@/modules/policy/store/policyStore.model';
import type {
  ReinstatementAddress,
  ReinstatementSigner,
  ReinstatementUser,
} from '@/modules/Reinstatement/store/reinstatementStore.model.ts';
import { RouteNames } from '@/router/routeNames';
import type { RouteParamsGeneric } from 'vue-router';

const componentOptions: ComponentOptions = {
  name: 'ReinstatementLayout',
  mixins: [openInNewWindow],
  components: {
    ReinstatementProcessOverview,
    ReinstatementProcessOptions,
    ReinstatementProcessInformation,
    ReinstatementProcessNextSteps,
    NavigationConfirmationDialog,
    ReinstatementOriginalIssueDate,
    ReinstatementOriginalIssueNextSteps,
    ReinstatementNYStepThree,
    MessageDialog,
  },
  data() {
    return {
      asyncProcessInProgress: false,
      policyReinstatementStep: '1',
      nyPolicyReinstatementStep: 1,
      mobileView: false,
      showNavigationConfirmationDialog: false,
      navigatingToRoute: '' as string | null,
      navigatingToParams: {} as RouteParamsGeneric,
      navigationAwayConfirmed: false,
      isReinstatementProcessDone: false,
      userSelectedReinstatmentOption: -1,
      showErrorPostPolicyReinstatement: false, // Use this to test error dialog
      userInformation: {
        primaryName: '',
        spouseName: '',
        primaryEmailAddress: '',
        primaryMobilePhone: '',
        spouseEmailAddress: '',
        spouseVerifyEmailAddress: '',
        spouseMobilePhone: '',
      },
      address: {
        address1: '',
        address2: '',
        city: '',
        state: '',
        country: '',
      },
      spouseFirstName: '' as string | null | undefined,
      spouseLastName: '' as string | null | undefined,
    };
  },
  computed: {
    ...mapState(useGlobalStore, {
      currentLocale: 'getLocale',
    }),
    ...mapStores(usePolicyStore),
    ...mapState(usePolicyStore, {
      currentPolicy: 'currentPolicy',
      policies: 'policies',
    }),
    ...mapState(useCustomerStore, ['customerProfile']),
    isMobileView() {
      return this.$vuetify.display.xs;
    },
    getContractId() {
      return this.currentPolicy?.contractId;
    },
    goToAOFlow() {
      // redirect user to AO note flow
      return !this.currentPolicy?.reinstatement?.eligibleDod; // window.appConfig.reinstatement.override ||
    },
    isCurrentPolicyCountryUS() {
      return (
        this.currentPolicy?.contractId?.substr(0, 2) === '04' ||
        this.currentPolicy?.contractId?.substr(0, 2) === '34'
      );
    },
    isCurrentPolicyCountryCAN() {
      return (
        this.currentPolicy?.contractId?.substr(0, 2) !== '04' &&
        this.currentPolicy?.contractId?.substr(0, 2) !== '34'
      );
    },
  },
  methods: {
    ...mapActions(useReinstatementStore, ['postPolicyReinstatement']),
    ...mapActions(usePolicyStore, ['getPolicyOverview']),
    setReinstatementOption(option: number) {
      this.userSelectedReinstatmentOption = option;
    },
    async goToDashboard() {
      this.asyncProcessInProgress = true;
      await this.policyStore.getPolicyOverview(true); // send a refresh flag to get the latest policy reinstatement status
      this.asyncProcessInProgress = false;
      this.isReinstatementProcessDone = true;
      this.$router.push({ name: RouteNames.DASHBOARD });
    },
    async continueToTheNextReinstatementStep(
      userOrAddressObj: ReinstatementUser | ReinstatementAddress | null
    ) {
      // Overview, Options, Information, Next Steps
      switch (this.policyReinstatementStep) {
        case '1': // Overview
          this.policyReinstatementStep = '2';
          break;
        case '2': // Options
          this.policyReinstatementStep = '3';
          break;
        case '3':
          // TODO: refactor reusable logic see case 4

          // alert(JSON.stringify(userObj, 1, 3));
          if (this.userSelectedReinstatmentOption === 1) {
            this.userInformation = userOrAddressObj;
            this.policyReinstatementStep = '4';
          } else if (this.userSelectedReinstatmentOption === 0) {
            // Original Option
            // this.address1 = userOrAddressObj.streetaddress1;
            // this.address2 = userOrAddressObj.streetaddress2;
            // this.city = userOrAddressObj.city;
            // this.state = userOrAddressObj.state;
            // this.zip = userOrAddressObj.zip;
            // TODO: use isCurrentPolicyCountryUS || isCurrentPolicyCountryCAN
            let country;
            if (
              this.currentPolicy.contractId?.substr(0, 2) === '04' ||
              this.currentPolicy.contractId?.substr(0, 2) === '34'
            ) {
              country = 'US';
            } else {
              country = 'CA';
            }
            // start
            const addressObj = userOrAddressObj as ReinstatementAddress | null;
            const reInstatementPayloadObj = {
              type: 'ORG', // NEW (New Date) / ORG (Original Date)
              state: this.currentPolicy?.owner?.address?.state || '', // Client life policy address state
              locale: this.currentLocale,
              language: this.currentPolicy?.data?.secondaryLanguage,
              // Address exists only if type = ORG
              address: {
                address1: addressObj?.streetaddress1 ?? '',
                address2: addressObj?.streetaddress2 ?? '',
                city: addressObj?.city ?? '',
                state: addressObj?.state ?? '',
                country: country,
                zip: addressObj?.zip,
              },
              signers: [] as ReinstatementSigner[],
            };

            const signers = [];

            const ownerObj =
              // Owner is required
              {
                name: `${this.customerProfile?.firstName} ${this.customerProfile?.lastName}`,
                role: 'Owner',
                emailAddress: this.customerProfile?.email,
                mobilePhone: this.userInformation.primaryMobilePhone,
              };
            signers.push(ownerObj);

            this.spouseFirstName = this.currentPolicy?.data?.spouseFirstName;
            this.spouseLastName = this.currentPolicy?.data?.spouseLastName;
            const spouseObj = {
              name: `${this.spouseFirstName} ${this.spouseLastName}`,
              role: 'Spouse',
              emailAddress: '', // TODO since this is not being passed to us
              mobilePhone: '', // What should we do for Original date?
            };
            if (this.spouseFirstName && this.spouseFirstName.length > 0) {
              // ONLY if there is Spouse
              signers.push(spouseObj);
            }
            reInstatementPayloadObj.signers = signers;

            try {
              this.asyncProcessInProgress = true;
              // For Original Date users don't see the DOD popup link
              await this.postPolicyReinstatement({
                policyNumber: this.currentPolicy?.contractId || '',
                reinstatementPayload: reInstatementPayloadObj,
              });

              // this.isReinstatementProcessDone = true;
              // await this.$router.push({ name: RouteNames.DASHBOARD });
              await this.policyStore.getPolicyOverview(true); // send a refresh flag to get the latest policy reinstatement status
              this.policyReinstatementStep = '4';
            } catch (_e) {
              this.showErrorPostPolicyReinstatement = true;
            } finally {
              this.asyncProcessInProgress = false;
            }
            // end
          }

          // alert(JSON.stringify(this.userInformation, 1, 3));
          // Information
          break;
        case '4': {
          // TODO: refactor reusable logic see case 3 // Next Steps
          if (this.userSelectedReinstatmentOption === 1) {
            let tcountry;
            if (
              this.currentPolicy.contractId?.substr(0, 2) === '04' ||
              this.currentPolicy.contractId?.substr(0, 2) === '34'
            ) {
              tcountry = 'US';
            } else {
              tcountry = 'CA';
            }
            // call postPolicyReinstatement

            // alert(JSON.stringify(this.userInformation, 1, 3));
            // const owner = this.userInformation;
            const reInstatementPayloadObj = {
              type: 'NEW', // NEW (New Date) / ORG (Original Date)
              state: this.currentPolicy?.owner?.address?.state || '', // Client life policy address state
              locale: this.currentLocale,
              language: this.currentPolicy?.data?.secondaryLanguage,
              // Address exists only if type = ORG
              address: {
                address1: this.currentPolicy?.owner?.address?.address1 || '',
                address2: this.currentPolicy?.owner?.address?.address2 || '',
                city: this.currentPolicy?.owner?.address?.city || '',
                state: this.currentPolicy?.owner?.address?.state || '',
                country: tcountry,
              },
              signers: [] as ReinstatementSigner[],
            };

            const signers = [];

            const ownerObj =
              // Owner is required
              {
                name: `${this.customerProfile?.firstName} ${this.customerProfile?.lastName}`,
                role: 'Owner',
                emailAddress: this.customerProfile?.email,
                mobilePhone: this.userInformation.primaryMobilePhone,
              };
            signers.push(ownerObj);

            this.spouseFirstName = this.currentPolicy?.data?.spouseFirstName;
            this.spouseLastName = this.currentPolicy?.data?.spouseLastName;
            const spouseObj = {
              name: `${this.spouseFirstName} ${this.spouseLastName}`,
              role: 'Spouse',
              emailAddress: this.userInformation.spouseEmailAddress,
              mobilePhone: this.userInformation.spouseMobilePhone,
            };
            if (this.spouseFirstName && this.spouseFirstName.length > 0) {
              // ONLY if there is Spouse
              signers.push(spouseObj);
            }
            reInstatementPayloadObj.signers = signers;
            try {
              this.asyncProcessInProgress = true;
              const redirectUrl = await this.postPolicyReinstatement({
                policyNumber: this.currentPolicy?.contractId || '',
                reinstatementPayload: reInstatementPayloadObj,
              });

              const isWeb = CapacitorFacade.isWeb();
              // Add the redirectUrl to the policy so that they will see the "Complete and Submit" button
              const tcontractId = this.currentPolicy?.contractId || '';
              const tempPolicy = this.policyStore.policies.find(
                (policy: IPolicyStorePolicy) => policy.contractId === tcontractId
              );
              if (tempPolicy) tempPolicy.reinstatement.redirectUrl = redirectUrl;
              const tPolicies = await JSON.parse(JSON.stringify(this.policies));
              this.policyStore.policies = tPolicies;
              await this.openInNewWindow({
                url: redirectUrl,
                target: '_blank',
                inappbrowser: !isWeb,
              });
              this.isReinstatementProcessDone = true;
              await this.$router.push({ name: RouteNames.DASHBOARD });
            } catch (_e) {
              this.showErrorPostPolicyReinstatement = true;
            } finally {
              this.asyncProcessInProgress = false;
            }
          } else {
            await this.policyStore.getPolicyOverview(true); // send a refresh flag to get the latest policy reinstatement status
          }
          break;
        }
        default:
          // TODO: implement default
          this.asyncProcessInProgress = true;
          await this.policyStore.getPolicyOverview(true); // send a refresh flag to get the latest policy reinstatement status
          this.asyncProcessInProgress = false;
          await this.$router.push({ name: RouteNames.DASHBOARD });
          break;
      }
    },
    async continueToNYFinalStep(addressObj: ReinstatementAddress | null) {
      const reInstatementPayloadObj = {
        type: 'ORG', // NEW (New Date) / ORG (Original Date)
        state: this.currentPolicy?.owner?.address?.state || '', // Client life policy address state
        locale: this.currentLocale,
        language: this.currentPolicy?.data?.secondaryLanguage,
        address: {
          // Address exists only if type = ORG
          address1: addressObj?.streetaddress1 ?? '',
          address2: addressObj?.streetaddress2 ?? '',
          city: addressObj?.city ?? '',
          state: addressObj?.state ?? '',
          country: this.isCurrentPolicyCountryUS ? 'US' : 'CA',
          zip: addressObj?.zip,
        },
        signers: [] as ReinstatementSigner[],
      };

      const signers = [];
      const ownerObj = {
        // Owner is required
        name: `${this.customerProfile?.firstName} ${this.customerProfile?.lastName}`,
        role: 'Owner',
        emailAddress: this.customerProfile?.email,
        mobilePhone: this.userInformation.primaryMobilePhone,
      };
      signers.push(ownerObj);

      const isThereASpouse = this.spouseFirstName?.length;
      if (isThereASpouse) {
        // ONLY if there is Spouse
        this.spouseFirstName = this.currentPolicy?.data?.spouseFirstName;
        this.spouseLastName = this.currentPolicy?.data?.spouseLastName;
        const spouseObj = {
          name: `${this.spouseFirstName} ${this.spouseLastName}`,
          role: 'Spouse',
          emailAddress: '', // TODO since this is not being passed to us
          mobilePhone: '', // What should we do for Original date?
        };
        signers.push(spouseObj);
      }
      reInstatementPayloadObj.signers = signers;

      try {
        this.asyncProcessInProgress = true;
        await this.postPolicyReinstatement({
          policyNumber: this.currentPolicy?.contractId || '',
          reinstatementPayload: reInstatementPayloadObj,
        });
        await this.policyStore.getPolicyOverview(true); // send a refresh flag to get the latest policy reinstatement status
        this.nyPolicyReinstatementStep = 2;
      } catch (_e) {
        this.showErrorPostPolicyReinstatement = true;
      } finally {
        this.asyncProcessInProgress = false;
      }
    },
    async cancelFromReinstatementStep() {
      await this.$router.push({ name: RouteNames.DASHBOARD });
    },
    goToPreviousPage() {
      this.policyReinstatementStep = '2';
    },
    async navigateToRoute() {
      this.navigationAwayConfirmed = true;
      await this.$router.push({
        name: this.navigatingToRoute,
        params: this.navigatingToParams,
      });
    },
  },
  watch: {
    isMobileView(newVal /* , oldVal */) {
      this.mobileView = !newVal;
    },
  },
  created() {
    this.mobileView = this.$vuetify.display.xs;
  },
  beforeRouteLeave(to, _from, next) {
    const isReinstatementDone = this.isReinstatementProcessDone || this.navigationAwayConfirmed;
    const navigatingOutsidePolicyReinstatement =
      to.name !== RouteNames.POLICY_REINSTATEMENT && to.path !== '/reinstatement';
    if (navigatingOutsidePolicyReinstatement && !isReinstatementDone) {
      this.showNavigationConfirmationDialog = true; // show NavigationConfirmationDialog
      this.navigatingToRoute = to.name; // save the route name
      this.navigatingToParams = to.params;
      next(false); // cancel the navigation
    } else {
      next();
    }
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss">
.containerSize {
  max-width: 1024px;
  margin: auto;
}
.moveOnTopOfCircle {
  margin-left: -40px;
}
.fullWidth {
  width: 100%;
}
.v-stepper-item {
  color: gray;
  .v-stepper-item__avatar.v-avatar {
    background: gray;
  }

  &.v-stepper-item--selected,
  &.v-stepper-item--complete {
    color: #063562;
    .v-stepper-item__avatar.v-avatar {
      background: #063562;
    }
  }
}
.font-size--20.mobile-title-policy-request {
  font-size: 20px;
  margin-left: 0px;
  @media only screen and (max-width: 600px) {
    font-size: 18px;
    margin-left: 40px;
  }
}
</style>
